import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _class2, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Model, Store, referenceOne } from 'libx';
import { createIamAPI } from './API';
import moment from 'moment';
import env from '../misc/env';
import { observable, computed } from 'mobx';
export var TermsOfUseVersion = (_class = /*#__PURE__*/function (_Model) {
  function TermsOfUseVersion() {
    var _this;
    _classCallCheck(this, TermsOfUseVersion);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TermsOfUseVersion, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "workspaceId", _descriptor2, _this);
    _initializerDefineProperty(_this, "markup", _descriptor3, _this);
    _initializerDefineProperty(_this, "dateCreated", _descriptor4, _this);
    _initializerDefineProperty(_this, "dateModified", _descriptor5, _this);
    return _this;
  }
  _inherits(TermsOfUseVersion, _Model);
  return _createClass(TermsOfUseVersion, [{
    key: "parse",
    value: function parse(data) {
      return {
        id: data.id,
        workspaceId: data.workspace_id,
        markup: data.markup,
        dateCreated: data.date_created && moment(data.date_created),
        dateModified: data.date_modified && moment(data.date_modified)
      };
    }
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "workspaceId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "markup", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "dateCreated", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "dateModified", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _class);
export var TermsOfUseAgreement = (_class2 = /*#__PURE__*/function (_Model2) {
  function TermsOfUseAgreement() {
    var _this2;
    _classCallCheck(this, TermsOfUseAgreement);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _callSuper(this, TermsOfUseAgreement, [].concat(args));
    _initializerDefineProperty(_this2, "workspaceId", _descriptor6, _this2);
    _initializerDefineProperty(_this2, "userId", _descriptor7, _this2);
    _initializerDefineProperty(_this2, "acceptedAt", _descriptor8, _this2);
    _initializerDefineProperty(_this2, "touId", _descriptor9, _this2);
    return _this2;
  }
  _inherits(TermsOfUseAgreement, _Model2);
  return _createClass(TermsOfUseAgreement, [{
    key: "terms",
    get: function get() {
      return referenceOne(this.rootStore.termsOfUseStore.termsVersions, this.touId);
    }
  }, {
    key: "parse",
    value: function parse(data) {
      if (data.tou_id !== data.tou) {
        this.rootStore.termsOfUseStore.termsVersions.set(data.tou);
      }
      return {
        workspaceId: data.workspace_id,
        userId: data.user_id,
        acceptedAt: data.accepted_at && moment(data.accepted_at),
        touId: data.tou_id
      };
    }
  }]);
}(Model), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "workspaceId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "userId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "acceptedAt", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "touId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _applyDecoratedDescriptor(_class2.prototype, "terms", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "terms"), _class2.prototype), _class2);
var TermsOfUseStore = /*#__PURE__*/function (_Store) {
  function TermsOfUseStore() {
    var _this3;
    _classCallCheck(this, TermsOfUseStore);
    _this3 = _callSuper(this, TermsOfUseStore, arguments);
    _this3.termsVersions = _this3.collection({
      model: TermsOfUseVersion
    });
    _this3.agreements = _this3.collection({
      model: TermsOfUseAgreement,
      getDataId: function getDataId(data) {
        return "".concat(data.workspace_id, "/").concat(data.user_id, "/").concat(data.tou_id);
      },
      getModelId: function getModelId(model) {
        return "".concat(model.workspaceId, "/").concat(model.userId, "/").concat(model.touId);
      }
    });
    _this3.api = createIamAPI({
      baseURL: env.IAM_API,
      getToken: _this3.rootStore.authStore.getToken
    });
    return _this3;
  }
  _inherits(TermsOfUseStore, _Store);
  return _createClass(TermsOfUseStore, [{
    key: "getLatestTerms",
    value: function () {
      var _getLatestTerms = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var workspaceId,
          _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              workspaceId = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;
              if (!workspaceId) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", this.api.termsOfUse.getLatestForWorkspace(workspaceId).then(this.termsVersions.set));
            case 3:
              return _context.abrupt("return", this.api.termsOfUse.getLatest().then(this.termsVersions.set));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getLatestTerms() {
        return _getLatestTerms.apply(this, arguments);
      }
      return getLatestTerms;
    }()
    /**
     * Fetches user's agreements for given workspace
     *
     * @param {string} workspaceId
     *
     * @returns {Promise<TermsOfUseAgreement[]>}
     */
  }, {
    key: "getAgreements",
    value: (function () {
      var _getAgreements = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(workspaceId) {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.api.termsOfUse.getAcceptances(workspaceId, true);
            case 2:
              res = _context2.sent;
              return _context2.abrupt("return", this.agreements.set(res.data));
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getAgreements(_x) {
        return _getAgreements.apply(this, arguments);
      }
      return getAgreements;
    }()
    /**
     * Gets gloabl agreements and agreements for a member within specified workspace
     * with give user id
     *
     * @param {string} workspaceId
     *
     * @returns {Promise<TermsOfUseAgreement[]>}
     */
    )
  }, {
    key: "agreementsForWorkspaceMember",
    value: function agreementsForWorkspaceMember(workspaceId, userId) {
      return this.agreements.filter(function (a) {
        return a.userId === userId && (a.workspaceId === workspaceId || a.workspaceId === null);
      });
    }
  }]);
}(Store);
export { TermsOfUseStore as default };
//# sourceMappingURL=TermsOfUseStore.js.map
